import { Flex, FlexProps } from '@chakra-ui/react';
import { MemberDetailsTabs } from './components/MemberDetailsTabs';

const MemberDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <MemberDetailsTabs />
  </Flex>
);

export default MemberDetailsData;
